import * as actions from './index'

export const setData=(data)=>{
  return{
     type:actions.SET_DATA,
     data
  }
}

export const setDataKey=(data)=>{
  return {
    type:actions.SET_DATA_KEY,
    data
  }
}
export const getData=()=>{
  return{
    type:actions.GET_DATA
  }
}
export const getDataKey =()=>{
  return{
    type:actions.GET_DATA_KEY
  }
}
export const getAll =()=>{
    return{
      type:actions.GET_ALL
    }
  }